export default __webpack_public_path__ + "static/media/work_web-md@2x.58751b69.webp";